import irene from '../static/images/sectionTalking/2017/irene.png';
import irenePhoto from '../static/images/sectionTalking/2017/img-irene.png';
import chels from '../static/images/sectionTalking/2017/chels.png';
import chelsPhoto from '../static/images/sectionTalking/2017/img-chels.png';
import zaou from '../static/images/sectionTalking/2017/zaou.png';
import zaouPhoto from '../static/images/sectionTalking/2017/img-zaou.png';
import judy from '../static/images/sectionTalking/2017/judy.png';
import judyPhoto from '../static/images/sectionTalking/2017/img-judy.png';
import kevin from '../static/images/sectionTalking/2017/kevin.png';
import kevinPhoto from '../static/images/sectionTalking/2017/img-kevin.png';
import phin from '../static/images/sectionTalking/2017/phin.png';
import phinPhoto from '../static/images/sectionTalking/2017/img-phin.png';
import andrew from '../static/images/sectionTalking/2017/andrew.png';
import andrewPhoto from '../static/images/sectionTalking/2017/img-andrew.png';

export default [
    {
        name: "IRENE",
        position: "Front-End Developer",
        img: irene,
        photo: irenePhoto,
        article: `
          <p>早安 我是 Irene</p>
          <p>大學主要學設計的我，在大四那年突然深深的對寫程式感到著迷，靠著覺得寫程式是一件很浪漫的事情，傻傻投了履歷，很幸運地進來了新芽。</p>
          <p>很快的一年要過了，如果你問我新芽跟原本想像的有什麼不同？其實一切都很好，只是沒想到玩的時間會這麼多...</p>
          <p>其實說真的，我一直覺得大家上班都在玩，下班也在玩，人手一台 Switch 還是很正常的事？不過大家卻也都能在時間之內做完工作，還游刃有餘，讓我大開眼界。當然，除了玩樂之餘，在新芽的這一年，我也學到了很多東西，而且這些成長不僅僅是學會了幾種開發的語言，更多的是</p>
          <p>『 如何去成為一位更好的工程師 』</p>
          <p>學會去檢視自己的 code，然後寫出別人也能看懂的程式碼。</p>
          <p>很高興能夠在這裡實習，也很感謝 mentor 們的指導，雖然要學的東西還很多很多，但我想這會是我進入社會前，最寶貴也最難得的收穫。</p>
          <p>所以呢，如果你不想當看起來很宅的工程師，想要一邊玩一邊工作，或是想要磨練自己讓自己變得更強，快來吧！新芽絕對是一個不錯的地方喔！</p>
        `,
    },
    {
        name: "CHELSEA",
        position: "UI Designer",
        img: chels,
        photo: chelsPhoto,
        article: `
          <p>能夠到新芽實習大概就是來台灣之後最幸運的事了！</p>
          <p>一開始想說暑假這麼閒，不要再耍廢了，來試試看找實習吧！看到新芽的徵實習貼文的時候其實已經比第一波的面試時間還要晚，想著算了吧都過了，幸好後來還是鼓起勇氣私訊新芽小編，順利獲得面試機會，來到了這個大家庭！</p>
          <p>正式來實習後，真的被這裡輕鬆的工作氣氛嚇到！大家看起來都是一副很閒、在玩樂的樣子，到開會的時候又很認真的腦力激盪，完全體現了 “work hard, play hard” 的真諦，心裡想著天啊真的是一群超強的人欸！</p>
          <p>來到新芽參與了一些專案之後，才真正了解到一個好的UI設計是怎樣被創造出來——要仔細的觀察、嚴謹的設計，結合工程師與客戶的意見，再經過重覆又重覆的改善，才能產出一個使用者用得得心應手的產品。即使我一個星期實習的天數不多， mentor 們也很用心的幫助和解答我的問題，也會認真聽取我的建議，尊重我的想法，我也從他們身上學到要從別的角度審視自己的設計。</p>
          <p>在這裡大家的關係都不會僅僅是同事，不會一下班就打卡走人，而會聚在一起聊天玩遊戲開趴，變成一群夥伴，所以如果你也渴望有一些既能聊天打屁，又能熱血工作的夥伴們的話，新芽一定是不二之選，快點來加入我們吧！</p>
        `,
    },
    {
        name: "ZAOU",
        position: "Project Management",
        img: zaou,
        photo: zaouPhoto,
        article: `
          <p>來到新芽是段很奇幻的歷程，在這裡真的能學到很多在學外接觸不到的事情，不管是跟 Mentor 一起出去參加提案，或是跟著參與設計提案，都是超乎想像的體驗 XD</p>
          <p>雖然大學唸的是中文，對設計與程式一竅不通，但還是很幸運的能夠加入其中成為一份子，在這裡的一切都很不可思議，一起打電動、抓寶可夢跟看電影，不管哪一段，回想起來都是會不知不覺微笑的回憶。我覺得新芽就像一個很大很大的家庭，包容所有不同特質的人，每個人都能很舒適的在這裡找到自己的位置，並且發揮自己的長才與價值，更別提那些超猛的福利了，如果你也不安於現狀，想要留下一些特別的回憶，並且快速累積實戰經歷，歡迎趕快來 25sprout 投遞履歷，絕對不會讓你失望的。</p>
        `,
    },
    {
        name: "JUDY",
        position: "Marketing",
        img: judy,
        photo: judyPhoto,
        article: `
          <p>我很幸運可以進來新芽實習，在這裡短短一年的經驗，就讓我從零開始，學到了很多經驗，包括文案撰寫、社群平台的經營、還有數據觀察及分析！</p>
          <p>這是我第一個實習，剛開始進來時還有點怕生。但是大家都很熱情，中午都會圍一圈在餐桌開心吃飯聊天，分享彼此的生活，垃圾話不間斷，所以緊張感過不久就消除了 XD</p>
          <p>但更讓我開眼界的是，原來大家工作時會在遊戲沙發區打電動，公司的 Switch 戰隊居然有快 20 個人，還有人會揪團看鋼鍊！不過大家很厲害的是，就算花這麼多時間「公開」玩樂，工作一樣做的完！</p>
          <p>我在 SurveyCake 裡擔任行銷，自己進來之前，完全沒接觸過商管領域，也不會 AI、PS，一切都是從頭學起，很謝謝團隊裡的每個人都很熱心也很有耐心的分享！</p>
          <p>在這裡，學習是無止盡的，只要你有心，不怕學不到東西！</p>
        `,
    },
    {
        name: "KEVIN",
        position: "Android App Developer",
        img: kevin,
        photo: kevinPhoto,
        article: `
          <p>在新芽的日子即將要滿一年了，對於這邊真的只有滿滿的感謝！這個實習機會對於一個大四準畢業生真的很難得，能夠參與專案開發和學習業界的技術真的很酷！</p>
          <p>這段時間遇見了兩位 Mentor – 小馬和 Bill。小馬是個幽默可愛的原住民，常常讓辦公室充滿歡笑，他的開發經驗非常豐富，每次問他問題都會有意想不到的收穫，也是我吉他社的得意門生（握拳）；Bill 是個很 Nice 的人，像我的哥哥一樣！我們合作了兩個專案，即便是腦袋打結問一些笨問題，他也會耐心的跟我解釋，很喜歡一起吃午餐配陰屍路的日子！</p>
          <p>這邊的社團活動真的超活躍，基本上每天下班後都會有活動可以讓你選擇，自己參加了羽球隊和吉他社。喜歡在羽球場邊和同事聊聊近況，也很喜歡每次羽球隊訓結束大家一起吃宵夜的時光，總是能聽到一些關於公司或同事間有趣的事情 ；記得在剛進公司的第一個禮拜，~就莫名其妙被 Alex 指派為吉他社社長~，於是吉他社的練習就這麼開始啦！只要大家有想學的歌，吃完午餐我就會在遊戲區手把手教學，學不完下班後再留下來特訓！</p>
          <p>新芽真的是個超棒的地方，趕快投履歷加入我們吧！別讓自己的青春留下遺憾！</p>
        `,
    },
    {
        name: "PHIN",
        position: "Administrator & Finance",
        img: phin,
        photo: phinPhoto,
        article: `
          <p>很開心可以進入新芽，這段日子裡負責了行政的大小事，把辦公室顧好讓大家可以安心衝刺！</p>
          <p>主責很多是吃吃喝喝相關，把大家餵飽是件很有成就感的事情。</p>
          <p>另外也參與了員工福利活動的規劃，比如每個月大家都很期待的慶生會、年底萬眾矚目的尾牙、發人深省的年度發展會議、四月新芽周年慶以及香汗淋漓的運動會等，跟新芽的大家一起經歷這些，讓自己找資料跟協調的能力都更上一層樓了。</p>
          <p>而且大家都很容易 HIGH，過程非常暖心 XD</p>
          <p>新芽的氣氛輕鬆歡樂，但又總能在時間內完成該做的事情，這樣時間管理的能力相當令人敬佩呀。</p>
          <p>如果你也嚮往這樣的環境，就快投遞履歷過來吧！</p>
        `,
    },
    {
        name: "ANDREW",
        position: "iOS App Developer",
        img: andrew,
        photo: andrewPhoto,
        article: `
          <p>在申請實習前，蒐集很多關於新芽的資訊，包括 CEO Alex 的 medium、辦公室的開箱文，公司平時熱鬧的場景，這些都令我嚮往。</p>
          <p>如果以為耳聞的福利不過是徵人的手段，那你就大錯特錯！這裡的企業文化開放、新穎，沒有過多的規定及限制，這種賦能的風格的確振奮人心，不僅僅能從導師身上學到東西，在這裡沒有部門間的隔閡，若你也想體驗難以置信的福利與氣氛，新芽絕對是不二首選！</p>
        `,
    },
];



// WEBPACK FOOTER //
// ./src/models/Sprouters2017.js